import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'selectoptionControl',
  templateUrl: './select-option.component.html',
  styleUrls: ['./select-option.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class SelectOptionComponent implements OnInit {

  public formGroup: FormGroup;
  @Output() selectedToParent = new EventEmitter<any>();
  @Input() formControlFieldName: string;
  @Input() placeholder: string = 'Select';
  @Input() options: any[] = [];
  @Input() key: string = 'masterId';
  @Input() keyValue: string = 'name';
  @Input() displayOptionFor: string = 'default';
  @Input() defaultValue: boolean = true;
  @Input() disable: boolean = false;

  constructor(private ctrlContainer: FormGroupDirective) { }

  ngOnInit(): void {
    this.formGroup = this.ctrlContainer.form;
    const control = new FormControl('');
    this.formGroup.addControl(this.formControlFieldName, control);
  }

  sendToParent(selected: any) {
    this.selectedToParent.emit(selected);
  }

}